import React, { FC } from 'react';
import KeyVisual from './KeyVisual';
import BrandIntro from './BrandIntro';
import CardEvent from './CardEvent';
import Notice from './Notice';
import CallToAction from './CallToAction';
import NolCardEventBenefits from './NolCardBenefits/NolCardEventBenefits';
import NolCardBaseBenefits from './NolCardBenefits/NolCardBaseBenefits';
import CardEventBanners from './CardEventBanners';
import Tabs from './Tabs';
import Tips from './Tips';
import ToTopButton from '@/components/Common/ToTopButton/ToTopButton';

import styles from './index.module.scss';
import NolPromotionShare from '@/components/NolPromotion/NolPromotionShare';
import AlreadyHasCard from './BottomSheets/AlreadyHasCard';
import CIBottomSheet from './BottomSheets/CIBottomSheet';
import SignUpCompleteBottomSheet from './BottomSheets/SignUpCompleteBottomSheet';
import CIConfirmPopup from '@/components/NolPromotion/NolPromotionPopup/CIConfirmPopup';
import LoginConfirmPopup from '@/components/NolPromotion/NolPromotionPopup/LoginConfirmPopup';
import AgreementCompletePopup from '@/components/NolPromotion/NolPromotionPopup/AgreementCompletePopup';
import MarketingTerms from '@/components/Member/MarketingTerms/MarketingTerms';
import PointBottomSheet from './BottomSheets/PointBottomSheet';
import LoungeBottomSheet from './BottomSheets/LoungeBottomSheet';
import TopingMemberShipBottomSheet from './BottomSheets/TopingMembershipBottomSheet';
import DiscountCouponBottomSheet from './BottomSheets/DiscountCouponBottomSheet';
import TripeDiscountCouponBottomSheet from './BottomSheets/TipleDiscountCouponBottomSheet';
import CIFailPopup from '@/components/NolPromotion/NolPromotionPopup/CIFailPopup';
import NotAvailablePopup from '@/components/NolPromotion/NolPromotionPopup/NotAvailablePopup';
import BlockingPopup from '@/components/NolPromotion/NolPromotionPopup/BlockingPopup';
import { NolPromotionStore } from '@/stores/NolPromotionStore';
import GoldClassCouponBottomSheet from './BottomSheets/GoldClassCouponBottomSheet';
import NolCardFlightOffersBottomSheet from './BottomSheets/NolCardFlightOffersBottomSheet';
import NolPromotionAgreement0903Modal from '@/components/NolPromotion/NolPromotionAgreementModal/NolPromotionAgreement0903Modal';
import ApplyPayBottomSheet from '@/components/NolPromotion/NolPromotionBody/Version0428/BottomSheets/CashbackBottomSheet';
import { isFeatureEnabled } from '@/utils/feature-flag/is-feature-enabled';
import PassAuthSdkPopup from '@/components/NolPromotion/NolPromotionPopup/PassAuthSdkPopup';

interface VersionBodyProps {
  store: NolPromotionStore;
  eventNolCouponPeriod: string;
  eventPeriod: string; // 이번 이벤트 기간
  eventCashbackPeriod: string; // 캐시백 이벤트 기간 (이것만 다름)
  eventBefore6MonthPeriod: string; // 이번 이벤트 이전 6개월 기간
  eventDisabledCashbackList: string[]; // 캐시백 이벤트 적용 불가 케이스
  eventCashbackDate: string; // 캐시백 지급 날짜. e.g. 조건 충족 시 {value},
}

const Version0428Body: FC<VersionBodyProps> = ({
  store,
  eventNolCouponPeriod,
  eventPeriod,
  eventCashbackPeriod,
  eventBefore6MonthPeriod,
  eventDisabledCashbackList,
  eventCashbackDate,
}) => {
  // 이벤트 기간 세팅
  store.eventNolCouponPeriod = eventNolCouponPeriod;
  store.eventPeriod = eventPeriod;
  store.eventCashbackPeriod = eventCashbackPeriod;
  store.eventBefore6MonthPeriod = eventBefore6MonthPeriod;
  store.eventDisabledCashbackList = eventDisabledCashbackList;
  store.eventCashbackDate = eventCashbackDate;

  return (
    <div>
      <KeyVisual />
      <Tabs />
      <NolCardEventBenefits />
      <NolCardBaseBenefits />
      <Tips />
      <CardEvent />
      <BrandIntro />
      <CardEventBanners />
      <Notice
        deliberationTitle={'여신금융협회 심의필 제 2026 - C1h - 05488호'}
        deliberationDescription={'(2026.04.17 ~ 2027.04.16)'}
      />
      <CallToAction />
      <div className={styles.topButtonContainer}>
        <ToTopButton />
      </div>

      {/*바텀시트*/}
      <NolPromotionShare />
      <AlreadyHasCard />
      <CIBottomSheet />
      <SignUpCompleteBottomSheet />
      <NolPromotionAgreement0903Modal />
      <CIConfirmPopup />
      <LoginConfirmPopup />
      <AgreementCompletePopup />
      <MarketingTerms pageName={store.pageName} store={store.marketingTermsStore} />
      <PointBottomSheet />
      <LoungeBottomSheet />
      <TopingMemberShipBottomSheet />
      <DiscountCouponBottomSheet />
      <ApplyPayBottomSheet />
      <GoldClassCouponBottomSheet />
      <TripeDiscountCouponBottomSheet />
      <NolCardFlightOffersBottomSheet />
      <CIFailPopup />
      <NotAvailablePopup />
      <BlockingPopup />
      {isFeatureEnabled('YAWEB-6561--plcc-new-pass-auth') ? <PassAuthSdkPopup /> : null}
    </div>
  );
};

export default Version0428Body;
